import { createGlobalStyle, css } from 'styled-components';

import Wrapper from 'xpi-black-ui/Base/Wrapper/styles';
import KeyValue from 'xpi-black-ui/Common/KeyValue/styles';
import ContextBox from 'xpi-black-ui/Base/ContentBox/styles';
import { SearchBarWrapper } from 'xpi-black-ui/Common/SearchBar/styles';
import SidebarFilters from 'xpi-black-ui/Feature/SidebarFilters/styles';
import { DatePickerStyles } from 'xpi-black-ui/Common/DatePicker/styles';

export default createGlobalStyle`
  body, span, p, input, a, button, textarea, select {
    font-family: Roboto!important;
  }

  soma-container {
    margin: auto;
  }

  ${KeyValue} {
    & > span:first-child {
      color: #B8B8B8;
      line-height: 21px!important;
    }
    & > span:last-child {
      color: #fff;
      font-size: 16px;
      line-height: 24px;
    }
  }

  ${Wrapper} {
    padding: 24px;
  }

  ${ContextBox} {
    padding: 16px;
  }

  ${SidebarFilters}, .sidebar-page {
    width: 252px;
    padding: 24px;
    min-width: 252px;
    margin-top: 24px;
    border-radius: 7px;
  }

  ${SidebarFilters} {
    & > div ul {
      max-height: 80px!important;
    }
  }

  ${SearchBarWrapper} {
    padding: 0 8px;
  }

  ${DatePickerStyles} {
    .DateRangePicker, .SingleDatePicker {
      .DateInput {
        width: 76px;
      }

      .DateRangePickerInput {
        &_calendarIcon {
          padding: 0 0 4px 8px;
        }
      }
      .SingleDatePickerInput {
        &_calendarIcon {
          padding: 0;
        }
      }
    }
  }
`;
